import { createContext } from 'react';

import type { PermissionsContentReturnType } from './types/permission-context-return.type';

import { isAuthorizedUnset } from './utilities/is-authorized-unset.util';

/**
 * React context for managing and providing permissions-related state throughout the application.
 *
 * @remarks
 * This context provides information about the current authorization state, loading status,
 * and error state for permissions. It uses a default value where authorization is unset,
 * and both loading and error states are false.
 *
 * @see PermissionsContentReturnType
 * @see isAuthorizedUnset
 */
export const PermissionsContext = createContext<PermissionsContentReturnType>({
  clearCache: async () => {
    // No-op function for clearing cache, to be implemented in the provider.
    return new Promise((resolve) => {
      resolve();
    });
  },
  isAuthorized: isAuthorizedUnset,
});
